$(document).ready(function(){
  var ddVal;
  var hideh2 = $("#new_ticket .request-form ol").prev("p");
  
  $("#request_type").change(function () {
    ddVal = this.value;
  });
  
  /*
  $("#new_ticket .request-form p").first().css( "display", "none" );
  $(".ticket-comments p").first().css( "display", "none" );
  $("#new_ticket .request-form ol").css( "display", "none" );
  $("#new_ticket .request-form ol").prev("p").css( "display", "none" );
  $("#new_ticket .request-form ol").prev("p").prev('h2').css( "display", "none" );
  //$('.ticket-reason').empty();
  //$('.ticket-reason').append("<span class='hr'><hr></span>");
  $('.ticket-reason h2').css( "display", "none" );
  $('.ticket-reason').css({"font-weight": "bold", "font-size": "20px"});
  $('.ticket-comments h2').css( "display", "none" );
  $('#request_type').parent("p").css( "display", "none" );
  $('#request_type').parent("p").prev('h2').css( "display", "none" );
  $('#request_type').parent("p").prev('h2').prev('hr').css( "display", "none" );
  $('.ticket-header h2').prepend('<h2 class="ticket-info">TICKET INFORMATION</h2>'); */
});